import axios from '@/utils/axios.js'
import { Header } from 'element-ui'


//上传头像
export function uploadHeadImage(data) {
    return axios({
        url: '/upload/uploadBase64',
        method: 'post',
        data
    })
}

//上传图片
export function uploadFreePhoto(data) {
    return axios({
        url: '/upload/uploadFreePhoto',
        method: 'post',
        data
    })
}


export function uploadPhoto(data) {
    return axios({
        url: '/upload/uploadPhoto',
        method: 'post',
        data
    })
}



//////////////////
// WEBPACK FOOTER
// ./src/api/upload.js
// module id = uzBN
// module chunks = 41